module.exports = __webpack_public_path__ + "img/onboarding-checklist.2ec920a1.svg";